import API from "./api";

const asArray = (data) => {
  if (Array.isArray(data)) return data;
  if (Array.isArray(data?.items)) return data.items;
  return [];
};

export const getAdminSettlements = async () => {
  const res = await API.get("/admin/settlements");
  return asArray(res.data);
};

export const getAdminSettlement = async (id) => {
  const res = await API.get(`/admin/settlements/${id}`);
  return res.data;
};

export const ensureAdminSettlement = async (reservationId) => {
  const res = await API.post(`/admin/settlements/ensure/${reservationId}`);
  return res.data;
};

export const updateAdminSettlement = async (id, data) => {
  const res = await API.patch(`/admin/settlements/${id}`, data);
  return res.data;
};

export const settleAdminSettlement = async (id) => {
  const res = await API.post(`/admin/settlements/${id}/settle`);
  return res.data;
};
